// extracted by mini-css-extract-plugin
export default {"uploadedFile":"uploadedFile__UploadedFile__sCaI8","name":"name__UploadedFile__sCaI8","size":"size__UploadedFile__sCaI8","delete":"delete__UploadedFile__sCaI8"};